import Flickity from "flickity";
import "flickity/dist/flickity.min.css";
import { fitText } from "../utils/fitText";
import { CountUp } from "countup.js";
import { Odometer } from "odometer_countup";
import ScrollTrigger from "gsap/ScrollTrigger";

function paddedFormat(n, intDigits, decimalPlaces) {
  if (decimalPlaces > 0) {
    const [int, dec] = n.toFixed(decimalPlaces).split(".");
    return String(Math.abs(parseInt(int))).padStart(intDigits, "0") + "." + dec;
  }
  return String(Math.abs(Math.floor(n))).padStart(intDigits, "0");
}

export default function Statsblock() {
  Alpine.data("statsblock", () => ({
    _flkty: null,
    _mql: null,
    resizeTimeout: null,

    init() {
      this.fit = this.fit.bind(this);
      this.debouncedResize = this.debouncedResize.bind(this);

      const track = this.$el.querySelector("[data-track]");
      if (track) {
        this._mql = window.matchMedia("(min-width: 768px)");

        const setup = () => {
          if (!this._mql.matches && !this._flkty) {
            this._flkty = new Flickity(track, {
              cellAlign: "left",
              contain: true,
              wrapAround: false,
              pageDots: false,
              prevNextButtons: false,
              draggable: true,
            });
            this._flkty.on("dragStart", () =>
              this._flkty.slider.childNodes.forEach(
                (slide) => (slide.style.pointerEvents = "none"),
              ),
            );
            this._flkty.on("dragEnd", () =>
              this._flkty.slider.childNodes.forEach(
                (slide) => (slide.style.pointerEvents = "all"),
              ),
            );
          } else if (this._mql.matches && this._flkty) {
            this._flkty.destroy();
            this._flkty = null;
          }
        };

        requestAnimationFrame(() => setup());
        this._mql.addEventListener("change", setup);
      }

      window.addEventListener("resize", this.debouncedResize);
      setTimeout(
        () =>
          requestAnimationFrame(() => {
            this.fit();
            this.countup();
          }),
        0,
      );
    },

    debouncedResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => requestAnimationFrame(this.fit), 0);
    },

    fit() {
      const numbers = Array.from(this.$el.querySelectorAll("[data-number]"));
      fitText(numbers, {
        maxFontSize: 140,
      });
      numbers.forEach((el) => {
        const anim = el.parentElement?.querySelector("[data-number-animation]");
        if (anim) anim.style.fontSize = el.style.fontSize;
      });
    },

    countup() {
      this.$el
        .querySelectorAll("[data-number-animation] [data-count]")
        .forEach((el) => {
          const raw = el.dataset.value ?? "";
          const value = parseFloat(raw.replace(/,/g, ""));
          if (isNaN(value)) return;

          const decimalPlaces = (raw.split(".")[1] ?? "").length;
          const intDigits = String(Math.floor(Math.abs(value))).length;

          const counter = new CountUp(el, value, {
            startVal: 0,
            decimalPlaces,
            useGrouping: false,
            formattingFn: (n) => paddedFormat(n, intDigits, decimalPlaces),
            plugin: new Odometer({ duration: 0.4, lastDigitDelay: 0 }),
            duration: 0.6,
            ease: (t) => t,
          });

          ScrollTrigger.create({
            trigger: el,
            start: "top 75%",
            once: true,
            onEnter: () => {
              console.log("count up!");
              counter.start();
            },
          });
        });
    },

    destroy() {
      window.removeEventListener("resize", this.debouncedResize);
      clearTimeout(this.resizeTimeout);
      if (this._flkty) {
        this._flkty.destroy();
        this._flkty = null;
      }
    },
  }));
}
